<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'DocumentsCountLabel',

    functional: true,

    props: {
        count: {
            type: [String, Number],
            required: true,
            validator: (value) => String(value) === 'all' || !isNaN(value),
        },
    },

    render(createElement, {props, data, parent}) {
        const count = props.count === 'all'
            ? parent.$t('documents.all')
            : parent.$tc('documents.count', props.count);

        data.props = {
            item: count,
            iconClass: 'far fa-fw fa-file-alt',
        };

        return createElement(DataLabel, data);
    },
};
</script>
